import {
    fetch
} from './fetch'
import da from "element-ui/src/locale/lang/da";

//首页数据
export function GetBanner() {
    return fetch({
        url: '/api/index/getHomeData',
        method: 'post',
        data: {}
    })
}
//获取产品列表
export function getPageBanner() {
    return fetch({
        url: '/api/index/getPageBanner',
        method: 'post',
        data: {}
    })
}
//获取产品列表
export function getProductList(data) {
    return fetch({
        url: '/api/index/getProductList',
        method: 'post',
        data: {
            group_id:data.group_id,
            name:data.name,
            page:data.page,
            limit:data.limit
        }
    })
}
//获取产品详情
export function getProductInfo(data) {
    return fetch({
        url: '/api/index/getProductInfo',
        method: 'post',
        data: {
            id:data.id,
        }
    })
}

//获取招纳贤士列表
export function getRecruitList(data) {
    return fetch({
        url: '/api/index/getRecruitList',
        method: 'post',
        data: {
            page:data.page,
            limit:data.limit,
        }
    })
}

//获取新闻列表
export function getNewsList(data) {
    return fetch({
        url: '/api/index/getNewsList',
        method: 'post',
        data: {
            type:data.type,
            page:data.page,
            limit:data.limit,
        }
    })
}
//获取新闻详情
export function getNewsInfo(data) {
    return fetch({
        url: '/api/index/getNewsInfo',
        method: 'post',
        data: {
            id:data.id,
        }
    })
}
//获取配置信息
export function getConfig() {
    return fetch({
        url: '/api/index/getConfig',
        method: 'post',
        data: {}
    })
}
//获取新闻详情
export function getAddressList() {
    return fetch({
        url: '/api/index/getAddressList',
        method: 'post',
        data: {}
    })
}
//获取公司介绍模块
export function getCompanyIntro() {
    return fetch({
        url: '/api/index/getCompanyIntro',
        method: 'post',
        data: {}
    })
}
//获取文化理念详情
export function getCultureInfo() {
    return fetch({
        url: '/api/index/getCultureInfo',
        method: 'post',
        data: {}
    })
}
//获取荣誉列表
export function getHonor(data) {
    return fetch({
        url: '/api/index/getHonor',
        method: 'post',
        data: {
            page:data.page,
            limit:data.limit
        }
    })
}
//获取分组列表
export function getGroupList(data) {
    return fetch({
        url: '/api/index/getGroupList',
        method: 'post',
        data: {
            type:data.type,
        }
    })
}
//获取分组列表
export function getProductMoreList(data) {
    return fetch({
        url: '/api/index/getProductMoreList',
        method: 'post',
        data: {
            group_id:data.group_id,
            name:data.name,
            page:data.page,
            limit:data.limit
        }
    })
}
//获取分组列表
export function getCourseInfo() {
    return fetch({
        url: '/api/index/getCourseInfo',
        method: 'post',
        data: {}
    })
}